import axios from "../../api/axiosInstance";
import { readStoredUser } from "../../utils/sessionUser";
import { buildDeliveryNoteUnitOptions } from "./deliveryNoteUnits";

// Reference prices are estimates, never evidence of the price printed on this note.
// The server prioritizes an applicable supplier tender, then the latest posted
// purchase, preserving whether that historical price was estimated.
export async function fetchDeliveryNoteReferencePrice({ line, item, businessUnitId, supplierId,
  date, currency = "EUR", excludeDeliveryNoteId, requestClient = axios, unitMap, languageId }) {
  const user = readStoredUser();
  const isCurrent = () => {
    const current = readStoredUser();
    return user?.id && String(current?.id) === String(user.id)
      && Number(current?.active_business_unit_id) === Number(businessUnitId);
  };
  if (!businessUnitId || !isCurrent()) throw new Error("The business unit changed.");
  const itemId = line?.item_id || line?.suggested_item_id;
  const option = buildDeliveryNoteUnitOptions(item, unitMap, languageId)
    .find((entry) => entry.level === line?.unit_level);
  if (!itemId || !option?.unitId || !option.inventoryUnitId || !supplierId || !date) {
    throw new Error("Select an item, supplier, date and valid unit first.");
  }
  const { data } = await requestClient.get(`/api/purchasing/delivery-notes-direct/reference-price/${itemId}`, {
    params: { unit_level: line.unit_level, supplier_id: supplierId, date, currency,
      ...(excludeDeliveryNoteId ? { exclude_delivery_note_id: excludeDeliveryNoteId } : {}) },
    pilcoreExpectedUserId: user.id,
    headers: { "X-Pilcore-Business-Unit-Id": businessUnitId },
  });
  if (!isCurrent()) throw new Error("The business unit changed.");
  if (data?.price === null) return null;
  const price = Number(data?.price);
  // Do not silently reuse a price for a stale unit configuration or another currency.
  if (!(price > 0) || !Number.isFinite(price) || data.currency !== currency
    || !["tender", "last_purchase"].includes(data.source)
    || data.unit_level !== option.level || String(data.unit_id) !== String(option.unitId)
    || String(data.inventory_unit_id) !== String(option.inventoryUnitId)
    || Math.abs(Number(data.unit_factor) - option.factor) > 1e-8 || !Number.isFinite(Number(data.unit_factor))) {
    throw new Error("The reference price does not match this line's units or currency.");
  }
  return { price, currency, unitLabel: option.label, deliveryDate: data.delivery_date, source: data.source,
    deliveryNoteNumber: data.delivery_note_number,
    referencePriceStatus: data.reference_price_status };
}
